import Axios2 from "./axios2v";
import AxiosManager from "./axiosManager";

const setPortal = (domain) => {
  if (domain) {
    AxiosManager.defaults.headers.common["portal"] = domain;
  } else {
    delete AxiosManager.defaults.headers.common["portal"];
  }

  if (domain) {
    Axios2.defaults.headers.common["portal"] = domain;
  } else {
    delete Axios2.defaults.headers.common["portal"];
  }
};

export default setPortal;
